import { TargetListPageEnum } from "../../../pages/targetList/dto";
import { SelectTarget } from "../../../pages/targetList/select/companySelect";
import { TargetIcon } from "../../../ui/icons/target";
import { AccordionFilter } from "../../../ui/organisms/accordionFilter";
import { useAppSelector } from "../../redux/hooks";
import { FindAllContactsFilters } from "../dto";

interface Props {
  updateFilters: (filter: Partial<FindAllContactsFilters>) => void
  filters: FindAllContactsFilters
}

export function TargetFilter(props: Props) {
  const { updateFilters, filters } = props
  const targetListState = useAppSelector((state) => state.targetList);

  return (
    <AccordionFilter
      disabled={
        window.location.pathname.includes("target") &&
        targetListState.targetListPage !== TargetListPageEnum.DB
      }
      key={"person-filter-target"}
      label={"Lista target"}
      icon={<TargetIcon color={""} size={0} />}
      showClear={
        filters.targetList.length > 0 &&
        (!window.location.pathname.includes("target") ||
          (window.location.pathname.includes("target") &&
            targetListState.targetListPage === TargetListPageEnum.DB))
      }
      options={filters.targetList}
      clearAction={function (): void {
        updateFilters({ targetList: [] })
      }}
      deleteFilter={function (option): void {
        updateFilters({
          targetList: filters.targetList.filter(
            (targetList) => targetList.value !== option.value
          )
        })
      }}
    >
      <SelectTarget
        id="select-target-list-filter"
        isMulti
        onChange={e => updateFilters({ ...filters, targetList: [...e ? e.map(item => ({ label: item as string, value: item as string })) : []] })}
        value={filters.targetList?.map(item => item.value)}
      />
    </AccordionFilter>
  );
}
